var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastResponder = function SvgFastResponder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "url(#pattern0_474_19002)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_474_19002",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_474_19002",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_474_19002",
    width: 40,
    height: 40,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAOVBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjXQ0ZAAAAEnRSTlMA0Z6Ev22V/foDIO8VsVgtOuNTb7IXAAAACXBIWXMAAAsTAAALEwEAmpwYAAABa0lEQVR42o2U3QKDIAiFMS38KSve/2GHlinZts7d2CcJHAFIcg6kusARfR2cx8VILdE9HF0VIUkhmbnPp8halLKWli7hSJZ6IW3yng6W7sMHqO8FmS/g9Acst/wNMvEqY8JsyNrtjzsi2SGu/tTsTnUgklp/TbOAzPE0fByloi/kCSIFzjeGW7P4OvoOagBNaXxSSEMLIuEGa3hoPrc05q8XcJ/F2K+OcmwQoHIwVRCx9VxjihvIP5u2mWIzPi5BrnUdON6A2bhIHThW+xUQ/HIHk3VA70pZAYLziagg/5Mm7CDmmi7QHc+BH8kBHrNkbgtnnVdGPsqDchdopmGawasyM1MNErfEN8UEz9VYuoM5bQV5asHresrIZSMy7toi0VNGAVLeCd9B/WiKB3DD9u/qnu5BQppvVSnMbh3oBuGvo902Pm3LTQ+nJpP3gdLrEydC/NIs2+jLnm6UVmwC4Z94WHrx8EIOXutCP7uNMJNxjFEZAAAAAElFTkSuQmCC"
  }))));
};
export default SvgFastResponder;